module.exports = __webpack_public_path__ + "img/uniuni.c58cb482.jpg";